import { Skeleton } from "@/components/shadcn/skeleton";
import { getImgProxyUrl } from "@/utils/image-proxy";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  src?: string;
  alt?: string;
  size?: string;
  className?: string;
};

const ImageProxy = ({
  src = "",
  alt = "",
  size = "size-12",
  className,
}: Props) => {
  const [loaded, setLoaded] = useState(false);

  const isSVG = src.endsWith(".svg");

  return (
    <Skeleton
      className={twMerge(
        `${size} shrink-0 animate-none overflow-hidden rounded bg-transparent`,
        isSVG && "bg-white p-2 pr-0",
        className,
      )}
    >
      <img
        src={getImgProxyUrl(src || null, [
          "resize:fill",
          "width:200",
          "height:200",
        ])}
        alt={alt}
        className="h-full object-cover object-left"
        style={{ opacity: loaded ? 1 : 0 }}
        onLoad={() => setLoaded(true)}
      />
    </Skeleton>
  );
};

export default ImageProxy;
